import { Theme, withStyles, WithStyles } from '@material-ui/core/styles'
import createStyles from '@material-ui/core/styles/createStyles'
import React from 'react'

import useSafeState from 'src/commons/hooks/useSafeState'
import ErrorSnackbar from 'src/components/Snackbar'

const styles = (theme: Theme) =>
  createStyles({
    root: {
      flex: 1,
      display: 'flex',
      flexDirection: 'column',
      background: theme.palette.background.paper,
      borderTopRightRadius: 'inherit',
      borderBottomRightRadius: 'inherit',
      paddingTop: theme.spacing(2),
      paddingBottom: theme.spacing(2),
      paddingRight: theme.spacing(1),
      paddingLeft: theme.spacing(1),
      overflowY: 'auto',
      overflowX: 'unset',
    },
    chartContainer: {
      flex: '1 1 100%',
    },
    halfContainer: {
      flex: '1 1 50%',
      width: '50%',
    },
    content: {
      display: 'flex',
      flexDirection: 'column',
      overflowY: 'scroll',
    },
    close: {
      padding: theme.spacing(1 / 2),
    },
  })

interface IProps extends WithStyles<typeof styles> {
  children: React.ReactNode
}

const BaseChartWrapper = (props: IProps) => {
  const { children, classes } = props
  const [errorMessage, setErrorMessage] = useSafeState('')

  return (
    <div className={classes.root}>
      <div className={classes.content}>{children}</div>
      <ErrorSnackbar open={errorMessage.length > 0} onClose={() => setErrorMessage('')} message={errorMessage} />
    </div>
  )
}

export default withStyles(styles)(BaseChartWrapper)
